import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.css";

import Navbar from "./component/Navbar/navbar";
import Footer from "./component/Footer/Footer";
import ScrollToTop from "./component/ScrollToTop/ScrollToTop";
import WhatsAppButton from "./component/WhatsAppButton/WhatsAppButton";
import Home from "./component/Home/Home";
import FullAbout from "./component/About/FullAbt";
import FullTeam from "./component/FullTeam/FullTeam";
import Projects from "./component/Projects/Projects";
import ProjectDetail from "./component/ProjectDetail/ProjectDetail";
import ServiceDetail from "./component/ServiceDetail/ServiceDetail";
import Contact from "./component/Contact/Contact";

function App() {
  return (
    <Router>
      <div className="app-container">
        {/* ScrollToTop must stay inside Router to work */}
        <ScrollToTop />
        {/* Floating WhatsApp button directly in right bottom corner below ScrollToTop */}
        <WhatsAppButton />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<FullAbout />} />
          <Route path="/services" element={<ServiceDetail />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/service/:slug" element={<ServiceDetail />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:slug" element={<ProjectDetail />} />
          <Route path="/project/:slug" element={<ProjectDetail />} />
          <Route path="/fullteam" element={<FullTeam />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;